import { Injectable } from '@angular/core';
import { environment } from '../../environments/environment';
import { HttpClient, HttpHeaders, HttpErrorResponse } from '@angular/common/http';
import { catchError } from 'rxjs/operators';
import { throwError,BehaviorSubject } from 'rxjs';
import { Router } from '@angular/router';
import { Subject } from 'rxjs-compat';



@Injectable({
  providedIn: 'root'
})
export class AuthService {

  private moduleName: string = "User";

  url = environment.endpoint + "/api/" + this.moduleName;
  authState = new BehaviorSubject(localStorage.getItem('authToken') ? true : false);
  userid = new BehaviorSubject(0);
  
  constructor(
    private http: HttpClient,
    private router: Router,
  ) { }

  getHeaders() {
    return {
      headers: new HttpHeaders({
        'Content-Type': 'application/json',
        'Authorization': 'Bearer ' + localStorage.getItem('authToken')
      })
    };
  }
  
  handleError(error: HttpErrorResponse) {
    console.log(error);
    return throwError(error);
  }

  logout(){
    localStorage.removeItem('authToken')
    this.authState.next(false);
    this.userid.next(0);
  }
  
  login(data: any) {
    // const url = this.url + '/api/maintenance/Authenticate';
    // const url = this.url + '/Authenticate';
    const url = this.url + '/portal/Authenticate';
    return new Promise(resolve => {
      this.http.post(url, data, this.getHeaders()).subscribe(
        response => {
          let res :any;
          res = response;
          console.log(res)
          localStorage.setItem('authToken', res['token'])
          localStorage.setItem('user', JSON.stringify(res))  
          this.authState.next(true);
          this.userid.next(res.id);
          resolve(res)
        },
        err => {
          this.logout();
          resolve(err)
        }
      );

    }).catch(err => {
      this.logout();
      console.log(err)
    })
  }
  
  relogin(data: any) {
    const url = this.url + '/portal/Authenticate';
    return new Promise(resolve => {
      this.http.post(url, data, this.getHeaders()).subscribe(
        response => {
          let res :any;
          res = response;
          console.log(res)
          localStorage.setItem('authToken', res['token'])
          localStorage.setItem('user', JSON.stringify(res))  
          this.authState.next(true);
          this.userid.next(res.id);
          resolve(res)
        },
        err => {
          // this.logout();
          resolve(err)
        }
      );

    }).catch(err => {
      // this.logout();
      console.log(err)
    })
  }

  checkAuthorization(page:string) {
    var UR = localStorage.getItem('userRole');
    var allowed = [];
    switch(page) {
      case "announcements" :      allowed = ['admin', 'agent'];
      case "branch-gallery":      allowed = ['admin', 'agent', 'merchant'];
      case "branches":            allowed = ['admin', 'agent', 'merchant'];
      case "cancellation":        allowed = ['admin', 'agent', 'merchant'];
      case "charges":             allowed = ['admin', 'agent', 'merchant'];
      case "charities":           allowed = ['admin', 'agent'];
      case "check-in":            allowed = ['admin', 'agent', 'receptionist'];
      case "check-out":           allowed = ['admin', 'agent', 'receptionist'];
      case "check-in-check-out":  allowed = ['admin', 'agent', 'merchant', 'receptionist'];
      case "room-type-gallery":   allowed = ['admin', 'agent', 'merchant'];
    }

    return allowed.indexOf(UR) > -1;
  }
}
